import Ext from 'Ext'

Ext.namespace('AT.menu');

const PickerItem = Ext.extend(Ext.menu.DateItem, {

    constructor : function(config, picker)
    {
        this.picker = picker;

        Ext.menu.DateItem.superclass.constructor.call(this, this.picker, config);

        this.addEvents('select');

        this.picker.on("render", function(picker)
        {
            picker.getEl().swallowEvent("click");
            picker.container.addClass("x-menu-date-item");
        });

        this.picker.on("select", this.onSelect, this);
    }
});

Ext.extend(PickerItem, Ext.menu.Adapter,
{
   // private
   onSelect : function(picker, date)
   {
       this.fireEvent("select", this, date, picker);
       PickerItem.superclass.handleClick.call(this);
   }
});

export default PickerItem



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_picker_item.js